import React from 'react'
import {Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import CustomerGroupController from "../../../../../services/qlts/admissions/customer-group-controller";
import DatePicker, {registerLocale} from "react-datepicker";
import vi from "date-fns/locale/vi";
import CustomerController from "../../../../../services/qlts/admissions/customer-controller";
import AddressManager from "../../../../../components/Address";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import QltsUserController from "../../../../../services/qlts/qlts-user-controller";
import {getSchoolYear} from "../../../../../utils/authority";
import StudentController from "../../../../../services/system/student/student-controller";
import GradeManager from "../../../../../components/Grade";
import {CustomerSourceType} from "../enums/customerSourceType";
import {CustomerStateType} from "../enums/customerStateType";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} />;
}
class CreateClient extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            appointmentDate: null,
            schoolName: "",
            testPoint: 0,
            testPoint_1: 0,
            testPoint_2: 0,
            testPoint_3: 0,

            listGroupCustomer: [],
            gradeId: "",
            testState: "UN_TESTED",
            oldSchoolName:'',
            provinceId:'',
            districtId:'',
            wardId:'',
            birthday: "",
            customerGroupId: -1,
            customerSource: "OTHER",
            customerState: "NEW",
            districtCode: "",
            fullName: "",
            gender: "MALE",
            identify: "",
            interestedContent: "",
            peopleInChargeUuid: null,
            partnerSearch: "",
            placeOfPermanent: "",
            provinceCode: "",
            schoolId: "",
            wardCode: "",
            yearId: "",

            fatherBirthday: "",
            fatherCareer: "",
            fatherCompanyName: "",
            fatherDateIdentify: null,
            fatherEmail: "",
            fatherEthic: "KINH",
            fatherFullName: "",
            fatherGender: "MALE",
            fatherIdentify: "",
            fatherPhone: null,
            fatherPlaceIdentify: "",
            fatherReligion: "NO",

            motherBirthday: "",
            motherCareer: "",
            motherCompanyName: "",
            motherDateIdentify: null,
            motherEmail: "",
            motherEthic: "KINH",
            motherFullName: "",
            motherGender: "MALE",
            motherIdentify: "",
            motherPhone: null,
            motherPlaceIdentify: "",
            motherReligion: "NO",

            rejectNote: "",
            note: "",
            currentClass: "",

        };
    }

    componentWillMount() {
        this.getListGroupCustomer()
        this.getListPeopleInCharge()
    }
    getListPeopleInCharge() {
        let payload = {
            "pageNumber": 0,
            "pageSize": 1000,
            "sort": "created_at desc"
        }
        QltsUserController.getList(payload, res => {
            if (res.success) {
                if (res.data.content.length > 0){
                    this.setState({
                        listPeopleInCharge:  res.data.content
                    })
                }
            }
        });
    }
    renderGroupCustomer = function () {
        return this.state.listGroupCustomer?.map((item, index) => <option value={item.id}>{item.name}</option>)
    };
    renderSourceCustomer = function () {
        return CustomerSourceType.map((item, index) => <option value={item.id}>{item.name}</option>)
    };
    renderCustomerStateType = function () {
        return CustomerStateType.map((item, index) => <option value={item.id}>{item.name}</option>)
    };

    getListGroupCustomer() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: 10,
            "sort": "created_at desc"
        };
        CustomerGroupController.getCustomerGroups(payload,res => {
            this.setState(
                {
                    showLoading: false
                }
            );
            if (res.success) {
                this.setState(
                    {
                        listGroupCustomer: res.data.content
                    }
                );
            } else {
            }
        });
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        })
    }
    onCreate = () => {
        let {fullName} = this.state;
        if (fullName == "" || fullName.length < 3){
            toast.error("Tên con phải lớn hơn 2 ký tự");
        }else if (this.state.customerState == "PROFILED" && this.state.gradeId == ""){
            toast.error("Vui lòng chọn khối học")
        }else {
            let {
                oldSchoolName, birthday, customerGroupId, customerSource, customerState, districtId, provinceId, wardId, fullName, gender, identify, interestedContent,
                peopleInChargeUuid, placeOfPermanent,
                fatherBirthday, fatherCareer, fatherCompanyName, fatherDateIdentify, fatherEmail, fatherEthic, fatherFullName,
                fatherGender, fatherIdentify, fatherPhone, fatherPlaceIdentify, fatherReligion,
                motherBirthday, motherCareer, motherCompanyName, motherDateIdentify, motherEmail, motherEthic, motherFullName,
                motherGender, motherIdentify, motherPhone, motherPlaceIdentify, motherReligion, testPoint, testState, phone,
                testPoint_1, testPoint_2, testPoint_3, schoolName, appointmentDate, rejectNote, note, currentClass
            } = this.state;
            let payload = {
                "oldSchoolName": oldSchoolName,
                "testPoint": parseInt(testPoint),
                "testState": testState,
                "appointmentDate": appointmentDate,
                "schoolName": schoolName,
                "testPoint_1": testPoint_1,
                "testPoint_2": testPoint_2,
                "testPoint_3": testPoint_3,

                "phone": phone,
                "birthday": birthday==""? null: birthday,
                "customerGroupId": parseInt(customerGroupId),
                "customerSource": customerSource,
                "customerState": customerState,

                "placeOfPermanent": placeOfPermanent,
                "districtCode": districtId,
                "provinceCode": provinceId,
                "wardCode": wardId,

                "fullName": fullName,
                "gender": gender,
                "identify": identify,
                "interestedContent": interestedContent,
                "peopleInChargeUuid": peopleInChargeUuid,
                "yearId": parseInt(getSchoolYear()),
                "parentsReq": [
                    {
                        "birthday": fatherBirthday==""? null: fatherBirthday,
                        "career": fatherCareer,
                        "companyName": fatherCompanyName,
                        "dateIdentify": fatherDateIdentify==""? null: fatherDateIdentify,
                        "email": fatherEmail,
                        "ethic": fatherEthic,
                        "fullName": fatherFullName,
                        "gender": fatherGender,
                        "identify": fatherIdentify,
                        "phone": fatherPhone,
                        "placeIdentify": fatherPlaceIdentify,
                        "religion": fatherReligion
                    },
                    {
                        "birthday": motherBirthday==""? null: motherBirthday,
                        "career": motherCareer,
                        "companyName": motherCompanyName,
                        "dateIdentify": motherDateIdentify==""? null: motherDateIdentify,
                        "email": motherEmail,
                        "ethic": motherEthic,
                        "fullName": motherFullName,
                        "gender": motherGender,
                        "identify": motherIdentify,
                        "phone": motherPhone,
                        "placeIdentify": motherPlaceIdentify,
                        "religion": motherReligion
                    }
                ],

                "rejectNote": rejectNote,
                "note": note,
                "currentClass": currentClass,
            }
            CustomerController.createCustomer(payload, res => {
                if (res.success) {
                    toast.success("Thêm khách hàng thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    });
                    setTimeout(() => {
                        this.props.navigate('/ad-sas-school/admissions/danh-sach-khach-hang');
                    }, 200)
                } else {
                    toast.warning(res.message[0], {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
            })
            if (this.state.customerState == "PROFILED"){
                let payload = {
                    "autoGenCode": true,
                    "bietBoi": false,
                    "birthday": birthday,

                    "birthdayFather": this.state.fatherBirthday,
                    "birthdayGiamHo": null,
                    "birthdayMother": this.state.motherBirthday,

                    "cheDoChinhSach": "CHE_DO_CHINH_SACH_1",
                    "cheDoHoTro": "CHE_DO_HO_TRO_1",
                    "choO": "TRONG_TRUONG",
                    "code": "",
                    "currentClassRoomId": 0,

                    "dangDay": null,
                    "dangVien":  false,
                    "dienHocSinh": "DIEN_HOC_SINH_1",

                    "districtCode": districtId,
                    "provinceCode": provinceId,
                    "wardCode": wardId,
                    "queQuan": placeOfPermanent,

                    "doanDay": null,
                    "doanVien": false,

                    "doiDay": null,
                    "doiTuongUuTien": "UU_TIEN_1",

                    "doiVien": "",
                    "email": "",
                    "ethnic": "KINH",

                    "fatherDanToc":  false,
                    "motherDanToc": false,

                    "fullName": fullName,
                    "fullNameFather": fatherFullName,
                    "fullNameGiamHo": "",
                    "fullNameMother": motherFullName,

                    "gender": gender,
                    "grade": this.state.gradeId,
                    "heHocNN": "TIENG_ANH",
                    "hinhThuc": "TRUNG_TUYEN",
                    "identify": "",
                    "ishocTruongTrinhGDBo": true,
                    "iskhuyetTat": false,
                    "khuyetTat": "KHUYET_TAT_1",

                    "jobFather": fatherCareer,
                    "jobGiamHo": "",
                    "jobMother": motherCareer,


                    "mailFather": fatherEmail,
                    "mailGiamHo": "",
                    "mailMother": motherEmail,


                    "nhomMau": "NHOM_MAU_1",
                    "noiSinh": placeOfPermanent,
                    "phone": phone,

                    "phoneFather": fatherPhone,
                    "phoneGiamHo": "",
                    "phoneHome": "",
                    "phoneMother": motherPhone,

                    "pointDegree": "TRUNG_BINH",

                    "religion":  "NO",
                    "schoolDay": new Date(),
                    "sodangbo": "",
                    "state": "CHUA_PHANLOP",
                    "taiDinhCu": false,
                    "tamTru": "",

                    "tengoiEthnnic": "",
                    "thanhPhanParent": "THANH_PHAN_PARENT_1",
                    "thuongTru": "",

                    "yearId": parseInt(getSchoolYear()),
                    "zone": "",
                }
                StudentController.create(payload, res => {
                    if (res.success){
                        toast.success("Đã thêm học sinh vào hệ thống trường!")
                    } else {
                        toast.error("Đã xảy ra lỗi! " + res.message)
                    }
                })
            }
        }
    }
    render() {
        let {provinceId, districtId, wardId, placeOfPermanent, gradeId}  = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-customer-admissions" parentClass="admissions-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thêm khách hàng tuyển sinh"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>THÊM MỚI KHÁCH HÀNG</h2>
                                        <div className="row">
                                            <div className="col-md-6 col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Họ và tên con(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    placeholder="Nhập tên con"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.fullName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fullName: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">SĐT Liên hệ(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    placeholder="Số điện thoại liên hệ phụ huynh"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.phone}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            phone: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Giới tính con</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.gender}
                                                    onChange={(e) => {
                                                        this.state.gender = e.target.value;
                                                        this.setState({
                                                            gender: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="">Giới tính</option>
                                                    <option value="MALE">Nam</option>
                                                    <option value="FEMALE">Nữ</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>

                                            <div className="col-md-6 col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày sinh con</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.birthday === '' ? null : new Date(this.state.birthday)}
                                                    maxDate={new Date()}
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    birthday: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-6 col-12 d-flex mb-2">
                                            </div>
                                            <AddressManager
                                                isEdit={true}
                                                addressUsually={placeOfPermanent}
                                                districtId={districtId}
                                                provinceId={provinceId}
                                                wardId={wardId}
                                                onUpdateAddress={(address, wardId, districtId, provinceId) => this.setState({placeOfPermanent: address, districtId: districtId, provinceId: provinceId, wardId: wardId})}
                                            />
                                            <div className="col-12 d-flex mb-2">
                                                <label className="col-md-2 col-4 label-item pl-0">Nội dung quan tâm</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.interestedContent}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            interestedContent: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Trường cũ</label>
                                                <input
                                                    placeholder="Trường hiện tại đang học"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.oldSchoolName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            oldSchoolName: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Mã định danh(CCCD/CMND)</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.identify}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            identify: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Lớp hiện tại</label>
                                                <input
                                                    placeholder="Lớp hiện tại đang học"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.currentClass}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            currentClass: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Lưu ý</label>
                                                <input
                                                    placeholder="Lưu ý về sức khỏe, gia đình,..."
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.note}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            note: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>

                                            <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Thông tin cha</div>
                                            <div className="col-md-6 col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Họ và tên cha</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.fatherFullName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fatherFullName: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày sinh cha</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state. fatherBirthday === '' ? null : new Date(this.state.fatherBirthday)}
                                                    maxDate={new Date()}
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    fatherBirthday: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số điện thoại cha</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.fatherPhone}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fatherPhone: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Gmail</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.fatherEmail}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fatherEmail: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>

                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nghề nghiệp cha</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.fatherCareer}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fatherCareer: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên công ty</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.fatherCompanyName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fatherCompanyName: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số CMND/CCCD</label>
                                                <input
                                                    placeholder="Số CMND/CCCD"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.fatherIdentify}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fatherIdentify: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3 col-6 d-flex mb-2">
                                                <DatePicker
                                                    placeholderText="Ngày cấp"
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.fatherDateIdentify === '' ? null : new Date(this.state.fatherDateIdentify)}
                                                    maxDate={new Date()}
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    fatherDateIdentify: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-3 col-6 d-flex mb-2">
                                                <input
                                                    value={this.state.fatherPlaceIdentify}
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    placeholder="Nơi cấp CCCD/CMND"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fatherPlaceIdentify: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Dân tộc</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.fatherEthic}
                                                    onChange={(e) => {
                                                        this.state.fatherEthic = e.target.value;
                                                        this.setState({
                                                            fatherEthic: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="KINH">Kinh</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tôn giáo</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.fatherReligion}
                                                    onChange={(e) => {
                                                        this.state.fatherReligion = e.target.value;
                                                        this.setState({
                                                            fatherReligion: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="NO">Không</option>
                                                    <option value="YES">Có</option>
                                                </select>
                                            </div>

                                            <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Thông tin mẹ</div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Họ và tên mẹ</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.motherFullName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            motherFullName: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày sinh mẹ</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state. motherBirthday === '' ? null : new Date(this.state.motherBirthday)}
                                                    maxDate={new Date()}
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    motherBirthday: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số điện thoại mẹ</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.motherPhone}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            motherPhone: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Gmail</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.motherEmail}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            motherEmail: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>

                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nghề nghiệp mẹ</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.motherCareer}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            motherCareer: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên công ty</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.motherCompanyName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            motherCompanyName: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số CMND/CCCD</label>
                                                <input
                                                    placeholder="Số CMND/CCCD"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.motherIdentify}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            motherIdentify: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3 col-6 d-flex mb-2">
                                                <DatePicker
                                                    placeholderText="Ngày cấp"
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.motherDateIdentify === '' ? null : new Date(this.state.motherDateIdentify)}
                                                    maxDate={new Date()}
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    motherDateIdentify: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-3 col-6 d-flex mb-2">
                                                <input
                                                    value={this.state.motherPlaceIdentify}
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    placeholder="Nơi cấp CCCD/CMND"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            motherPlaceIdentify: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Dân tộc</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.motherEthic}
                                                    onChange={(e) => {
                                                        this.state.motherEthic = e.target.value;
                                                        this.setState({
                                                            motherEthic: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="KINH">Kinh</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tôn giáo</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.motherReligion}
                                                    onChange={(e) => {
                                                        this.state.motherReligion = e.target.value;
                                                        this.setState({
                                                            motherReligion: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="NO">Không</option>
                                                    <option value="YES">Có</option>
                                                </select>
                                            </div>
                                            <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Thông tin bài Test</div>
                                            <div className="col-md-6  col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.testState}
                                                    onChange={(e) => {
                                                        this.state.testState = e.target.value;
                                                        this.setState({
                                                            testState: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="UN_TESTED">Chưa Test</option>
                                                    <option value="TESTED">Đã Test</option>
                                                    <option value="DIRECT_ENTRY">Tuyển thẳng</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6  col-xs-12 d-flex mb-2"></div>
                                            <div className="col-md-6  col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Điểm môn Toán</label>
                                                <input
                                                    value={this.state.testPoint}
                                                    maxLength={255} type="number"
                                                    className="form-control shadow-none"
                                                    placeholder="Nhập điểm thi môn toán"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            testPoint: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6  col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Điểm môn Văn</label>
                                                <input
                                                    value={this.state.testPoint_1}
                                                    maxLength={255} type="number"
                                                    className="form-control shadow-none"
                                                    placeholder="Nhập điểm thi môn văn"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            testPoint_1: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6  col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Điểm môn Anh</label>
                                                <input
                                                    value={this.state.testPoint_2}
                                                    maxLength={255} type="number"
                                                    className="form-control shadow-none"
                                                    placeholder="Nhập điểm thi môn Anh"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            testPoint_2: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6  col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Điểm môn khác</label>
                                                <input
                                                    value={this.state.testPoint_3}
                                                    maxLength={255} type="number"
                                                    className="form-control shadow-none"
                                                    placeholder="Nhập điểm thi môn khác"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            testPoint_3: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Thông tin khác</div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nhóm khách hàng(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.customerGroupId}
                                                    onChange={(e) => {
                                                        this.state.customerGroupId = e.target.value;
                                                        this.setState({
                                                            customerGroupId: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    {this.renderGroupCustomer()}
                                                </select>
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nguồn khách hàng(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.customerSource}
                                                    onChange={(e) => {
                                                        this.state.customerSource = e.target.value;
                                                        this.setState({
                                                            customerSource: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn nguồn khách hàng</option>
                                                    {this.renderSourceCustomer()}
                                                </select>
                                            </div>
                                            <div className="col-md-6 col-xs-12  d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Người phụ trách(<span  style={{color: "red",}}>*</span>)</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listPeopleInCharge}
                                                    getOptionLabel={option => option.fullName?option.fullName:"No Name"}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.partnerSearch}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Người phụ trách'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null)
                                                            this.setState({
                                                                partnerSearch: val
                                                            })
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.uuid != undefined){
                                                            this.state.peopleInChargeUuid = val?.uuid;
                                                            this.state.partnerSearch = val?.fullName;
                                                        }else {
                                                            this.state.peopleInChargeUuid = "";
                                                        }
                                                        // this.getListPeopleInCharge()
                                                    }}

                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Trạng thái(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.customerState}
                                                    onChange={(e) => {
                                                        this.state.customerState = e.target.value;
                                                        this.setState({
                                                            customerState: e.target.value
                                                        })
                                                    }}
                                                >
                                                    {this.renderCustomerStateType()}
                                                </select>
                                            </div>
                                            {this.state.customerState == "PROFILED" &&
                                                <React.Fragment>
                                                    <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                    </div>
                                                    <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                        <label className="col-4 label-item pl-0">Khối(<span  style={{color: "red",}}>*</span>)</label>
                                                        <GradeManager
                                                        isShowText={true}
                                                        gradeId={gradeId}
                                                        onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                        />
                                                    </div>
                                                </React.Fragment>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex align-right col-md-12 col-xs-12 row">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                        <button
                                            style={{minWidth: "fit-content", marginRight: "10px"}}
                                            type="button"
                                            className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                            onClick={() => this.onCreate()}
                                        >
                                        <span className='justify-content-center'>
                                            Lưu
                                        </span>
                                        </button>
                                        <button
                                            style={{minWidth: "fit-content"}}
                                            type="button"
                                            className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                            onClick={this.props.onHide}
                                        >
                                        <span className=''>
                                            Hủy bỏ
                                        </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
export default withRouter(CreateClient)
